"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PeakDataDefaults {
}
PeakDataDefaults.BaseUri = "https://peakdata.peakup.org";
exports.default = PeakDataDefaults;
